module.exports = __webpack_public_path__ + "static/SerifGothicStd-ExtraBold-11218ae43cd286eb2e94ce733c53d8b1.woff2";